module.exports = __webpack_public_path__ + "static/img/notes.b2de5ab.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/notes.png
// module id = 8IlJ
// module chunks = 0